import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { Delegation } from "../_types/delegation";

@Injectable({
  providedIn: 'root',
})
export class DelegationsService extends Service<Delegation> {
  public override type = 'delegations';
  public override url = 'common/delegations';
}
